import { useUser } from 'shared/hooks';
import { FreightPage } from './freight-page';

export function FreightPageResolver() {
  const user = useUser();

  if (!user) {
    return null;
  }
  return <FreightPage user={user} />;
}
